<script>
import { setWidgetValue, staticMixins } from "@/CommonDP/VForm/utils";

export default {
  mixins: [staticMixins],
  inheritAttrs: false,
  data() {
    return { rules: [] };
  },
  watch: {
    rules: {
      immediate: true,
      handler(newV, oldV) {
        this.$emit("rules:update", newV, oldV);
      }
    }
  },
  methods: {
    setWidgetValue,
    buildFieldRules() {}
  }
};
</script>
